// Auth-connection types.
//
// The response shapes are generated from OrbitalX.Dto — see api-generated.d.ts. The two request
// bodies below stay hand-written and camelCase: the worker serializer is case-INSENSITIVE on input,
// so they bind correctly, and re-casing them would change every call site for no behavioural gain.

export type {
  AuthConnectionDto,
  GoogleWorkspaceConfigDto,
  MicrosoftConfigDto,
} from './api-generated'

/**
 * Auth type as it reaches the dashboard: the [Description] value of the C# AuthenticationType, which
 * OrbitalX.Dto types as a plain `string`. `AUTH_TYPE` is checked against the generated union, so a
 * rename on the C# side fails to compile here rather than producing a value that never matches.
 */
export type AuthenticationType = string

export const AUTH_TYPE = {
  UsernamePassword: 'Username/Password',
  GoogleSocial: 'Google Social',
  GoogleWorkspace: 'Google Workspace',
  Microsoft: 'Microsoft'
} as const satisfies Record<string, import('./api-generated').AuthenticationType>

export interface GoogleWorkspaceCredentials {
  clientId: string
  clientSecret: string
  domain: string
  domainAliases?: string[]
}

/**
 * Microsoft Entra ID credentials.
 *
 * Not a renamed GoogleWorkspaceCredentials: Google takes a single `domain` that is both the
 * tenant identity and the email domain, while Microsoft splits them. `tenantDomain` is the Entra
 * tenant (contoso.onmicrosoft.com); `emailDomains` is what people actually sign in with
 * (contoso.com) and is what the connection matches a real user against. At least one email domain
 * is required — a connection carrying only a tenant domain matches nobody.
 */
export interface MicrosoftCredentials {
  clientId: string
  clientSecret: string
  tenantDomain: string
  emailDomains: string[]
}

export interface AddAuthConnectionRequest {
  type: AuthenticationType  // Auth type description string (e.g., "Google Social")
  googleWorkspace?: GoogleWorkspaceCredentials
  microsoft?: MicrosoftCredentials
}

export interface UpdateAuthConnectionRequest {
  isEnabled?: boolean
}
